module.exports = __webpack_public_path__ + "static/media/assistance_type_crane.5e1bd470.svg";